import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { Logo } from 'src/app/shared/logo-encode';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
imports: [CommonModule]

@Component({
  selector: 'lifedi-top-rank-informant',
  templateUrl: './top-rank-informant.component.html',
  styleUrls: ['./top-rank-informant.component.scss']
})
export class TopRankInformantComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  isLoading: boolean;

  data_report;

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    this.isLoading = true;

    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.measureService.getReportByMeasureId(body).pipe(
      map((res) => {
        this.data_report = res.result;
        setTimeout(() => {
          this.filepdf('email');
        }, 1000);
        this.isLoading = false;
      })
    ).subscribe();
  }

  filepdf(transfer) {
    let formattedDate = new DateTimePipe().transform(
      this.data_report.done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report.user_id;
    let alldata = this.data_report;
    let slider = [];
    let sliderInf = [];
    for (let i = 0; i < alldata.data.length; i++) {
      let a = document.getElementById('sliderpdf' + alldata.data[i].id);
      slider.push(a);
    }

    for (let i = 0; i < alldata.data2.length; i++) {
      let a = document.getElementById('sliderpdfInformant' + alldata.data2[i].id);
      slider.push(a);
    }

    Promise.all([...slider, ...sliderInf].map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        let halfIndex = Math.ceil(dataArray.length / 2);
        let std = dataArray.slice(0, halfIndex);
        let stdInf = dataArray.slice(halfIndex);

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report.reportname,
              alignment: 'center',
              fontSize: 20,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.measure_name,
              alignment: 'left',
              fontSize: 18,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.report_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [100],
                heights: [-4],
                body: [
                  [
                    {
                      text: 'ผู้ทำแบบทดสอบ',
                      fontSize: 13,
                      bold: true,
                      aligment: 'center',
                      fillColor: '#060e9f',
                      border: [true, true, true, true],
                      color: '#ffffff',
                      alignment: 'center',
                      margin: [0, 0],
                      borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                    }
                  ]
                ]
              }
            },
            {
              text: 'อันดับที่ 1',
              alignment: 'center',
              fontSize: 16,
              color: '#28A745',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report.data[0].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: '',
            },
            {
              text: this.data_report.data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              columns: [
                {
                  image: std[0],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report.data[0].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report.data[0].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report.data[0].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report.data[0].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report.data[0].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  },
                ],
              ],
            },
            {
              text: this.data_report.data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 0],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < this.data_report.data.length; i++) {
          let after = '';
          // if (i % 2 == 0) {
          //   after = 'before';
          // }

          allPage.content.push(
            {
              text: 'อันดับที่ ' + (i + 1),
              alignment: 'center',
              fontSize: 16,
              color: '#28A745',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report.data[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
            },
            {
              text: this.data_report.data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: std[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report.data[i].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report.data[i].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report.data[i].slider_value).toFixed(2) +
                      ' คะแนน',
                    // ' อยู่ในช่วงคะแนน ' +
                    // this.data_report.data[i].range +
                    // ' คะแนน',
                    width: '*',
                    color: this.data_report.data[i].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  }
                ],
              ],
            },
            {
              text: this.data_report.data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 0],
            },
          );
        }

        let parances = [];
        this.data_report.parances.forEach(e => {
          parances.push(`${e.EMAIL} (${e.TAG})`)
        });
        let parancesStr = (parances.join()).replace(/,/g, ', ')

        allPage.content.push(
          {
            text: '',
            alignment: 'left',
            decoration: '',
            color: '#fff',
            margin: [0, 0, 0, 0],
            width: 'auto',
            fontSize: 10,
            bold: false,
            pageBreak: 'after',
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [120],
              heights: [-5],
              body: [
                [
                  {
                    text: 'ผู้มีส่วนร่วมในแบบทดสอบนี้',
                    fontSize: 15,
                    bold: true,
                    aligment: 'center',
                    fillColor: '#060e9f',
                    border: [true, true, true, true],
                    color: '#ffffff',
                    alignment: 'center',
                    margin: [0, 0],
                    borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                  }
                ]
              ]
            }
          },
          {
            text: 'รายงานผลของผู้มีส่วนร่วมนี้เป็นของ',
            alignment: 'left',
            decoration: '',
            color: '#000',
            margin: [0, 10, 0, 8],
            width: 'auto',
            fontSize: 16,
            bold: true,
            pageBreak: '',
          },
          {
            text: parancesStr,
            width: '*',
            fontSize: 15,
            margin: [0, 0, 0, 15],
          },
        )

        for (let i = 0; i < this.data_report.data2.length; i++) {
          let after = '';
          if (i !== 0 && i % 2 == 0) {
            after = 'before';
          }

          allPage.content.push(
            {
              text: 'อันดับที่ ' + (i + 1),
              alignment: 'center',
              fontSize: 16,
              color: '#28A745',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.data2[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report.data2[i].COLOR_CODE,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 16,
              bold: true,
              pageBreak: after,
            },
            {
              text: this.data_report.data2[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 5],
            },
            {
              columns: [
                {
                  image: stdInf[i],
                  width: 180,
                  height: 100,
                  alignment: 'center',
                  margin: [0, -10, 10, 0],
                },
                [
                  {
                    text:
                      'คะแนนต่ำสุด : ' +
                      this.data_report.data2[i].min +
                      '    คะแนนสูงสุด : ' +
                      this.data_report.data2[i].max,
                    width: '*',
                    color: '#000000',
                    fontSize: 16,
                    bold: true,
                  },
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report.data2[i].slider_value).toFixed(2) +
                      ' คะแนน',
                    width: '*',
                    color: this.data_report.data2[i].COLOR_CODE,
                    margin: [0, 0, 0, 0],
                    fontSize: 16,
                    bold: true,
                  }
                ],
              ],
            },
            {
              text: this.data_report.data2[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, -50, 0, 0],
            },
          );
        }

        if (transfer === 'email') {
          let pdfDocGenerator = pdfMake.createPdf(allPage);
          pdfDocGenerator.getBase64((base64str) => {
            // console.log(base64str);
            let data = {
              MEASURE_ID: this.measureid,
              TYPE: this.type,
              base64str: base64str,
              view: this.view_status,
            };
            this.measureService.SaveReportMeasureId(data).subscribe((res) => {
              // console.log(res);
            });
          });
        } else if (transfer === 'download') {
          pdfMake.createPdf(allPage).open();
        }
      }
    );
  }
}
